import { FC, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

import { ControlProperties } from "../../../../page-control/property-panel/ControlProperties";
import { DesignEvent } from "../../../../../base/models";
import { DeviceType } from "./ToggleDeviceButtonGroup";
import { IPage } from "../../../models";
import { PageControlsToolbar } from "./PageControlsToolbar";
import { PageControlsViewSwitch } from "./PageControlsViewSwitch";
import { ResponsiveCanvas } from "./ResponsiveCanvas";
import { useDesignContext } from "../../../../../providers";

interface IPageControlsDesignerProps {
    page: IPage,
    onDesignChange: (event: DesignEvent) => void
}

export const PageControlsDesigner: FC<IPageControlsDesignerProps> = ({
    page, onDesignChange
}) => {
    const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Desktop);
    const { control: { element: control, dataSource, designerMode, setEditMode } } = useDesignContext()

    const getCanvasWithToolbar = () => {
        return <>
            <PageControlsToolbar
                editMode={designerMode}
                onEditModeChange={setEditMode}
                deviceType={deviceType}
                onDeviceTypeChange={setDeviceType} />
            <ResponsiveCanvas deviceType={deviceType}>
                <PageControlsViewSwitch
                    editMode={designerMode}
                    page={page}
                    onDesignChange={onDesignChange} />
            </ResponsiveCanvas>
        </>
    }

    const getControlProps = () => {
        if (!control)
            return <></>

        return <div className="h-100">
            <ControlProperties
                dataSource={dataSource}
                control={control}
                onDesignChange={onDesignChange} />
        </div>
    }

    const getDesignerBody = () => {
        if (!control)
            return <>{getCanvasWithToolbar()}</>

        return <>
            <PanelGroup direction="horizontal">
                <Panel defaultSize={75} minSize={75}>
                    {getCanvasWithToolbar()}
                </Panel>
                <PanelResizeHandle />
                <Panel defaultSize={25} maxSize={25}>
                    {getControlProps()}
                </Panel>
            </PanelGroup>
        </>
    }

    return <>
        <div className='position-relative designer-box'>
            {getDesignerBody()}
        </div>
    </>
}